import { OutlineButton, Modal, TextButton, PrimaryButton, InputDropdown, InputMoney, Input, InputDate } from "@artprov/design-system";
import PropTypes from "prop-types";
import { useModalFilter } from "../hooks/useModalFilter.js";
import { validateFecha, validateFechaRange, validateImporteRange, getRazonSocialHints, getFechaDesdeHints, getFechaHastaHints, getImporteDesdeHints, getImporteHastaHints, isAcceptButtonDisabled, hasAnyFilterFilled } from "../utils/modalFilter.validations.js";
import { useComprasAuth } from '../../../common/hooks/useComprasAuth.js';
export default function ModalFilter({ onFiltersApply }) {
  const { userDetails } = useComprasAuth();

  const validateUsername = !!userDetails?.userPurchasePermissions;

  const {
    // Estados
    isFilterModalOpen,
    setIsFilterModalOpen,
    resetKey,
    comprobantes,
    estadosFactura,
    sectores,

    // Estados del formulario
    tipoFacturaSelected,
    estadoFacturaSelected,
    importeDesde,
    importeHasta,
    razonSocial,
    fechaDesde,
    fechaHasta,
    sectorSelected,

    // Handlers
    handleAccept,
    handleClear,
    handleTipoFacturaChange,
    handleEstadoFacturaChange,
    handleRazonSocialChange,
    handleImporteDesdeChange,
    handleImporteHastaChange,
    handleFechaDesdeChange,
    handleFechaHastaChange,
    handleSectorChange,
  } = useModalFilter();

  // Opciones para el dropdown basadas en los datos cargados
  const opcionesTipoFactura = (
    comprobantes && comprobantes.length > 0
      ? [
        <InputDropdown.Option
          key="placeholder"
          id="placeholder"
          selected={!tipoFacturaSelected}
          value={""}
        >
          Seleccionar
        </InputDropdown.Option>,
        ...comprobantes.map((comprobante) => (
          <InputDropdown.Option
            key={`comp-${comprobante.ID}`}
            id={`comp-${comprobante.ID}`}
            selected={tipoFacturaSelected === comprobante.DESCRIPCION}
            value={comprobante.DESCRIPCION}
          >
            {comprobante.DESCRIPCION}
          </InputDropdown.Option>
        ))
      ]
      : [
        <InputDropdown.Option key="loading" value="" disabled>
          Cargando opciones...
        </InputDropdown.Option>
      ]
  );

  // Opciones para el dropdown de estados de factura
  const opcionesEstadoFactura = (
    estadosFactura && estadosFactura.length > 0
      ? [
        <InputDropdown.Option
          key="placeholder-estado"
          id="placeholder-estado"
          selected={!estadoFacturaSelected}
          value={""}
        >
          Seleccionar
        </InputDropdown.Option>,
        ...estadosFactura.map((estado) => (
          <InputDropdown.Option
            key={`estado-${estado.ID}`}
            id={`estado-${estado.ID}`}
            selected={estadoFacturaSelected === estado.DESCRIPCION}
            value={estado.DESCRIPCION}
          >
            {estado.DESCRIPCION}
          </InputDropdown.Option>
        ))
      ]
      : [
        <InputDropdown.Option key="loading-estado" value="" disabled>
          Cargando opciones...
        </InputDropdown.Option>
      ]
  );

  // Opciones para el dropdown de sectores
  const opcionesSector =
    sectores && sectores.length > 0
      ? sectores.map((sector) => (
        <InputDropdown.Option
          key={`sector-${sector.ID}`}
          id={`sector-${sector.ID}`}
          selected={sectorSelected === sector.DESCRIPCION}
          value={sector.DESCRIPCION}
        >
          {sector.DESCRIPCION}
        </InputDropdown.Option>
      ))
      : [
        <InputDropdown.Option key="loading-sector" value="" disabled>
          Cargando opciones...
        </InputDropdown.Option>,
      ];

  // Validación para el botón de aceptar
  const isAcceptDisabled = isAcceptButtonDisabled({
    razonSocial,
    importeDesde,
    importeHasta,
    fechaDesde,
    fechaHasta
  });

  // Validación para el botón "Borrar Filtro"
  const isClearDisabled = !hasAnyFilterFilled({
    tipoFacturaSelected,
    estadoFacturaSelected,
    razonSocial,
    importeDesde,
    importeHasta,
    fechaDesde,
    fechaHasta,
    sectorSelected,
  });

  return (
    <div>
      <OutlineButton
        variant="default"
        className="border-2 rounded-[4px] hover:border-2 hover:rounded-[4px]"
        size="medium"
        IconLeft="filter_list"
        onClick={() => setIsFilterModalOpen(true)}
      >
        Filtros
      </OutlineButton>

      {isFilterModalOpen && (
        <div className="relative z-[999]">
          <Modal.Container
            open={isFilterModalOpen}
            setOpen={setIsFilterModalOpen}
            closeOnClickOutside={false}
            onClose={() => setIsFilterModalOpen(false)}
          >
            <Modal.Content height="500px" width="720px" className="overflow-visible">
              <Modal.Header className="mb-2">
                <Modal.Title className="pl-2">Filtros</Modal.Title>
                <Modal.Close onClose={() => setIsFilterModalOpen(false)} />
              </Modal.Header>

              <Modal.Body>
              <div className="modal-content flex flex-col w-full">

                <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                  <InputDropdown
                    key={`tipo-factura-${resetKey}`}
                    label="Tipo de factura"
                    name="tipoFactura"
                    id="tipoFactura"
                    value={tipoFacturaSelected ?? undefined}
                    placeholder="Seleccionar"
                    status="default"
                    position="bottom"
                    fullWidth={true}
                    onChange={({ value }) => handleTipoFacturaChange(value)}
                  >
                    {opcionesTipoFactura}
                  </InputDropdown>

                  <Input
                    label="Razón social"
                    name="razonSocial"
                    id="razonSocial"
                    value={razonSocial}
                    className="w-[526px]"
                    placeholder="Ingresá la razón social del emisor"
                    hints={getRazonSocialHints(razonSocial)}
                    onChange={handleRazonSocialChange}
                  />
                </div>

                {validateUsername ? (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <InputDropdown
                      key={`estado-factura-${resetKey}`}
                      label="Estado de factura"
                      name="estadoFactura"
                      id="estadoFactura"
                      value={estadoFacturaSelected ?? undefined}
                      placeholder="Seleccionar"
                      status="default"
                      position="bottom"
                      onChange={({ value }) => handleEstadoFacturaChange(value)}
                    >
                      {opcionesEstadoFactura}
                    </InputDropdown>

                  {validateUsername && (
                    <InputDropdown
                      key={`sector-${resetKey}`}
                      label="Área derivante"
                      name="sector"
                      id="sector"
                      value={sectorSelected ?? undefined}
                      placeholder="Seleccionar"
                      status="default"
                      position="bottom"
                      onChange={({ value }) => handleSectorChange(value)}
                      multiSelect = {true}
                    >
                      {opcionesSector}
                    </InputDropdown>
                  )}
                  </div>
                ) : (
                    <InputDropdown
                      key={`estado-factura-${resetKey}`}
                      label="Estado de factura"
                      name="estadoFactura"
                      id="estadoFactura"
                      value={estadoFacturaSelected ?? undefined}
                      placeholder="Seleccionar"
                      status="default"
                      position="bottom"
                      onChange={({ value }) => handleEstadoFacturaChange(value)}
                    >
                      {opcionesEstadoFactura}
                    </InputDropdown>
                )}

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                    <InputDate
                      label="Fecha desde"
                      name="fechaDesde"
                      id="fechaDesde"
                      value={fechaDesde}
                      onChange={handleFechaDesdeChange}
                      classNameContainerInput="w-[318px]"
                      placeholder="Ej. 01/01/2020"
                      status={fechaDesde && (!validateFecha(fechaDesde) || (fechaHasta && validateFecha(fechaHasta) && !validateFechaRange(fechaDesde, fechaHasta))) ? "error" : "default"}
                      hints={getFechaDesdeHints(fechaDesde, fechaHasta)}
                      calendar={false}
                    />

                    <InputDate
                      label="Fecha hasta"
                      name="fechaHasta"
                      id="fechaHasta"
                      value={fechaHasta}
                      onChange={handleFechaHastaChange}
                      classNameContainerInput="w-[318px]"
                      placeholder="Ej. 01/12/2024"
                      status={fechaHasta && (!validateFecha(fechaHasta) || (fechaDesde && validateFecha(fechaDesde) && !validateFechaRange(fechaDesde, fechaHasta))) ? "error" : "default"}
                      hints={getFechaHastaHints(fechaHasta, fechaDesde)}
                      calendar={false}
                    />

                    <InputMoney
                      label="Importe desde"
                      name="importeDesde"
                      id="importeDesde"
                      value={importeDesde}
                      onChange={handleImporteDesdeChange}
                      className="px-1"
                      classNameContainer="w-[318px]"
                      autoComplete="off"
                      status={importeDesde && importeHasta && !validateImporteRange(importeDesde, importeHasta) ? "error" : "default"}
                      hints={getImporteDesdeHints(importeDesde, importeHasta)}
                      maxCharacters={12}
                    />

                    <InputMoney
                      label="Importe hasta"
                      name="importeHasta"
                      id="importeHasta"
                      value={importeHasta}
                      onChange={handleImporteHastaChange}
                      className="px-1"
                      classNameContainer="w-[318px]"
                      autoComplete="off"
                      status={importeDesde && importeHasta && !validateImporteRange(importeDesde, importeHasta) ? "error" : "default"}
                      hints={getImporteHastaHints()}
                      maxCharacters={12}
                    />
                  </div>


                </div>

              </Modal.Body>

              <Modal.Footer className="flex justify-end px-5">
                <div className="flex">
                  <TextButton
                    className="mx-2"
                    size="small"
                    onClick={handleClear}
                    disabled={isClearDisabled}
                  >
                    Borrar filtros
                  </TextButton>
                  <PrimaryButton
                    className="mx-2"
                    size="small"
                    onClick={() => handleAccept(onFiltersApply)}
                    classNameIcon="text-tertiary-100"
                    disabled={isAcceptDisabled}
                  >
                    Ver resultados
                  </PrimaryButton>
                </div>
              </Modal.Footer>
            </Modal.Content>
          </Modal.Container>
        </div>
      )}
    </div>
  );
}

ModalFilter.propTypes = {
  onFiltersApply: PropTypes.func.isRequired,
};
